import React from 'react';
import { IconEnhance } from '@spotify-internal/encore-web/core';
import * as Styled from '../AudioScriptPlaybackCard.styled';

const EmptyPlaybackCard = () => {
  return (
    <Styled.Container variant="default">
      <Styled.Content>
        <IconEnhance size="xxlarge" />
        <Styled.Text>Your message will appear here.</Styled.Text>
      </Styled.Content>
    </Styled.Container>
  );
};

export default EmptyPlaybackCard;
